import { createFileRoute } from '@tanstack/react-router';
import { ClerkLoginPage } from '@/pet/src/components/auth/ClerkLoginPage';

export const Route = createFileRoute('/login')({
  component: PetsoLogin,
});

function PetsoLogin() {
  return (
    <ClerkLoginPage
      userType="petso"
      redirectUrl="/dashboard"
    />
  );
}


